// src/api/patronesService.js
import { getDataList, getData, postPatronesBasico } from './common';

/**
 * Servicio para gestión de patrones (equipos de medición)
 */

/**
 * Obtener patrones disponibles (no en servicio)
 * @param {Object} filters - Filtros opcionales { magnitud, estado }
 * @returns {Promise} Lista de patrones disponibles
 */
export const getPatronesDisponibles = async (filters = {}) => {
  try {
    const conditions = {
      inService: false,
      estado: filters.estado || 'Activo'
    };

    if (filters.magnitud) {
      conditions.magnitud = filters.magnitud;
    }

    const response = await getDataList('Patrones', {
      conditions,
      sort: { inventario: 1 }
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener patrones disponibles:', error);
    throw error;
  }
};

/**
 * Obtener todos los patrones con información de estado
 * @param {Object} filters - Filtros opcionales
 * @returns {Promise} Lista de todos los patrones
 */

/**
 * Obtener estado actual de un patrón específico
 * @param {String} patronId - ID del patrón
 * @returns {Promise} Estado completo del patrón
 */
export const getPatronStatus = async (patronId) => {
  try {
    // Obtener información del patrón
    const patronResponse = await getData('Patrones', patronId);
    const patron = patronResponse.data.data;

    // Obtener movimiento activo si existe
    let currentMovement = null;
    let currentOts = [];
    let currentResponsible = null;

    if (patron.inService) {
      const movimientosResponse = await getDataList('patronesMovimientos', {
        conditions: {
          patronId: patronId,
          status: 'open'
        },
        sort: { startedAt: -1 },
        limit: 1
      });

      if (movimientosResponse.data.data.length > 0) {
        currentMovement = movimientosResponse.data.data[0];
        currentOts = currentMovement.otAssignments || [];
        currentResponsible = currentMovement.responsibleUserId;
      }
    }

    return {
      ok: true,
      data: {
        patron,
        inService: patron.inService,
        currentMovement,
        currentResponsible,
        currentOts,
        lastLocation: patron.ubicacion || 'Sin ubicación'
      }
    };
  } catch (error) {
    console.error('Error al obtener estado del patrón:', error);
    throw error;
  }
};

/**
 * Obtener historial de movimientos de un patrón
 * @param {String} patronId - ID del patrón
 * @param {Object} filters - Filtros { startDate, endDate, limit }
 * @returns {Promise} Historial de movimientos
 */
export const getPatronHistorial = async (patronId, filters = {}) => {
  try {
    const conditions = {
      patronId: patronId
    };

    if (filters.startDate || filters.endDate) {
      conditions.startedAt = {};
      if (filters.startDate) {
        conditions.startedAt.$gte = filters.startDate;
      }
      if (filters.endDate) {
        conditions.startedAt.$lte = filters.endDate;
      }
    }

    const response = await getDataList('patronesMovimientos', {
      conditions,
      sort: { startedAt: -1 },
      limit: filters.limit || 50
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener historial del patrón:', error);
    throw error;
  }
};

/**
 * Buscar patrones por texto (inventario, item, marca, modelo)
 * @param {String} searchText - Texto de búsqueda
 * @returns {Promise} Patrones encontrados
 */
export const searchPatrones = async (searchText) => {
  try {
    if (!searchText || searchText.trim() === '') {
      return { ok: true, data: [], total: 0 };
    }

    const response = await getDataList('Patrones', {
      conditions: {
        $or: [
          { inventario: { $regex: searchText, $options: 'i' } },
          { item: { $regex: searchText, $options: 'i' } },
          { marca: { $regex: searchText, $options: 'i' } },
          { modelo: { $regex: searchText, $options: 'i' } }
        ]
      },
      sort: { inventario: 1 },
      limit: 20
    });

    return response.data;
  } catch (error) {
    console.error('Error al buscar patrones:', error);
    throw error;
  }
};

/**
 * Obtener magnitudes disponibles (para filtros)
 * @returns {Promise} Lista de magnitudes únicas
 */
export const getMagnitudes = async () => {
  try {
    const response = await getDataList('magnitudes', {
      conditions: {},
      sort: { nombre: 1 }
    });

    return response.data;
  } catch (error) {
    console.error('Error al obtener magnitudes:', error);
    throw error;
  }
};

/**
 * Obtener estadísticas generales de patrones
 * @returns {Promise} Estadísticas
 */
export const getPatronesStats = async () => {
  try {
    const [disponibles, enServicio] = await Promise.all([
      postPatronesBasico({inService: false}  ),
      postPatronesBasico({inService: true, estado: 'Activo' })
    ]);

    console.log('Respuesta', disponibles,enServicio);
    return {
      ok: true,
      data: {
        totalDisponibles: disponibles.data.total || 0,
        totalEnServicio: enServicio.data.total || 0,
        totalPatrones: (disponibles.data.total || 0) + (enServicio.data.total || 0)
      }
    };
  } catch (error) {
    console.error('Error al obtener estadísticas de patrones:', error);
    throw error;
  }
};
